<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
	import {
		isPidToLogin,
		isInstallAddons
	} from '@/utils/util'
	import {
		SIGN
	} from '@/common/env.js'
	import share  from "@/utils/share/start.js"
	// #ifdef MP-WEIXIN
	let livePlayer = ''
	if (isInstallAddons('wechat_live')) {
		livePlayer = requirePlugin('live-player-plugin')
	}
	// #endif
	export default {
		globalData: {
			mall_name: '',
			global_cart_num: 0, // 购物车数量
		},
		onLaunch: function(options) {
			options.mall_default_sign = SIGN;
			this.initAppParams(options);
		},
		onShow: function(options) {
			// #ifdef MP-WEIXIN
			if (isInstallAddons('wechat_live')) {
				this.getWxShareParams(options)
			}
			this.updateWechat()
			// #endif
			// #ifdef APP-PLUS
			this.getScheme()
			// #endif
		},
		onHide: function(e) {
			console.log('App Hide', e);
		},
		methods: {
			getScheme() {
				var args = plus.runtime.arguments;
				//console.log(args, '----args----args-----')
				let type = args.split('=')[1]
				 //console.log(554,type)
				if(args && type == 'zhongjin') {
					console.log('跳转成功')
					uni.navigateTo({
						url: '/plugins/pages/order/list?tabIndex=0'
					})
				}else{
					
				}
			},
			// 小程序直播分享卡片/订阅消息/扫码二维码/广告/朋友圈等场景才能调用getShareParams接口获取以下参数
			getWxShareParams(options) { 
				const sceneList = [1007, 1008, 1014, 1044, 1045, 1046, 1047, 1048, 1049, 1073, 1154, 1155]
				if (sceneList.includes(options.scene)) {
					livePlayer.getShareParams()
						.then(res => {
							console.log('get share params sucess', res)
							let pid = res.custom_params.pid
							if(pid !== ''){
								uni.setStorageSync('pid', pid)
							}
						}).catch(err => {
							console.log('get share params err', err)
						})
				}
			},
			clearMallId(default_sign){ // 小程序切换不同商城sign得时候，需要清除对应缓存
				if(default_sign !== uni.getStorageSync("sign")){
					uni.removeStorageSync("sign")
					uni.removeStorageSync('token')
					uni.removeStorageSync('userInfo')
				}
			},
			clearStore() { // 切换不同商城sign得时候，需要清除对应缓存
				uni.removeStorageSync('token')
				uni.removeStorageSync('userInfo')
				uni.removeStorageSync('mall_config')
				uni.removeStorageSync('getAppId')
				uni.removeStorageSync('pid')
				uni.removeStorageSync('openid')
			},
			initMall() {
				if(Date.now()>uni.getStorageSync('mall_config_time')||1){
					this.$http.request({
						url: this.$api.setting.mall_config,
						method: 'POST'
					}).then(res => {
						console.log(333);
						if (res.code === 0) {
							let config = res.data;
							uni.setStorageSync('mall_config', config);
							let mall_config_time = Date.now()+1000*60*5; 
							uni.setStorageSync('mall_config_time', mall_config_time);
							uni.setStorageSync('tabbars', JSON.stringify(config.navbar));
							this.$store.commit('setMallConfig', config)
							this.$store.commit('setGlobalColor', this.setColor(config.global_text_color));
							//console.log(config.global_text_color,9999);
							share.init()
						}
					});
					
				}else{
					let mall_config = uni.getStorageSync('mall_config');
					this.$store.commit('setMallConfig', mall_config)
					uni.setStorageSync('tabbars', JSON.stringify(mall_config.navbar));
					this.$store.commit('setGlobalColor', this.setColor(mall_config.global_text_color))
					share.init()
					
				}
				
			},
			setColor(color) {
				let defaultColor = '#bc0100'
				if (typeof color === 'string') {
					return color || defaultColor
				} else {
					return defaultColor
				}
			},
			//小程序更新
			updateWechat() {
				if (uni.getUpdateManager) {
					const updateManager = uni.getUpdateManager();
					updateManager.onCheckForUpdate(function(res) {
						// 请求完新版本信息的回调
						// console.log(res.hasUpdate);
					});
					updateManager.onUpdateReady(function(res) {
						uni.showModal({
							title: this.state.lang.gengxintishi,
							content: this.state.lang.xinbanbenyijingzhunbeihao + '，' + this.state.lang
								.shifouzhongqiyingyong + '？',
							success(res) {
								if (res.confirm) {
									// 新的版本已经下载好，调用 applyUpdate 应用新版本并重启
									updateManager.applyUpdate();
								}
							}
						});
					});
					updateManager.onUpdateFailed(function(res) {
						// 新的版本下载失败
						uni.showModal({
							title: this.state.lang.yijingyouxinbanbenleyo,
							content: this.state.lang.xinbanbenyijingshangxianla + '~，' + this.state.lang
								.qingninshanchudangqianxiaochengxu + '，' + this.state.lang
								.chongxinsousuodakaiyo,
							showCancel: false
						});
					});
				}
			},
			// app更新
			updateApp() {
				let that = this;
				plus.runtime.getProperty(plus.runtime.appid, function(widgetInfo) {
					//APP更新
					that.$http.request({
						url: that.$api.app_update,
						data: {
							version_number: widgetInfo.version
						}
					}).then(res => {
						if (res.code == 0) {
							if (res.data.status == 1) { //1代表有新版本
								if (res.data.type == 0) { //0：全部更新

									uni.showModal({
										title: that.state.lang.tishi,
										showCancel: res.data.compulsive == 0 ? true :
										false, //是否强制更新：0：否 1：是
										content: res.data.remark,
										cancelText: that.state.lang.quxiao,
										confirmText: that.state.lang.queren,
										success: function(res2) {
											if (res2.confirm) {
												plus.runtime.openURL(res.data.address);
											} else if (res2.cancel) {

											}
										}
									})
								} else if (res.data.type == 1) { //1：部分更新
									uni.showModal({
										title: that.state.lang.tishi,
										content: res.data.remark,
										showCancel: res.data.compulsive == 0 ? true :
										false, //是否强制更新：0：否 1：是
										cancelText: that.state.lang.quxiao,
										confirmText: that.state.lang.queren,
										success: function(res2) {
											if (res2.confirm) {
												uni.navigateTo({
													url: '/pages/about/about?pageSource=2'
												})
											}
										}
									})
								}
							}

						} else {

						}
					})
				});
			}
		}
	};
</script>

<style lang="scss">
	/*每个页面公共css */
	@import "uview-ui/index.scss";
	@import "scss/index.scss";

	// /* 去除地图上高德地图标识符 */
	/* #ifdef H5 */
	.amap-copyright {
		display: none !important;
	}

	.amap-logo {
		display: none !important;
	}

	.amap-ui-control-zoom {
		width: 60rpx !important;
	}

	.amap-ui-control-zoom>* {
		width: 60rpx !important;
		height: 60rpx !important;
		line-height: 60rpx !important;
	}

	.amap-ui-control-theme-dark {
		display: none !important;
	}

	/* #endif */

	body.pages-index-index uni-page-body {
		font-size: 12px !important;
	}

	/deep/ uni-modal {
		z-index: 999999;
	}
</style>